import script from "./SideBarTextArea.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarTextArea.vue?vue&type=script&setup=true&lang=js"

import "./SideBarTextArea.vue?vue&type=style&index=0&id=0e39a866&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e39a866"]])

export default __exports__